import React from 'react';

import { HiOutlineTicket } from 'react-icons/hi';
import { IoClose } from 'react-icons/io5';
import PropTypes from 'prop-types';
import cn from 'classnames';

import { Button } from 'modules/common/input';
import { showModal, showAlert } from 'modules/common/modal';

import { useGetCart, useGetDiscount } from '../../hooks';
import DiscountModal from './DiscountModal';

export const DEFAULT_FORM = {
  apply_discount: false,
  selected_orders: [],
  discount_type: [],
};

function Discounts({ disabledButton, isAlertModal }) {
  const [cart, setCart, includes] = useGetCart();
  const [discounts, setDiscounts] = useGetDiscount(DEFAULT_FORM);

  const handleOnChange = (payload) => {
    setDiscounts((prevState) => ({
      ...prevState,
      ...payload,
      discount_type: payload?.discount_type,
    }));
  };

  const handleOnClick = () => {
    if (isAlertModal) {
      showAlert({
        buttonContainerClassName: 'hidden',
        title: (
          <div>
            <div>Add Discount</div>
            <div className="text-sm font-normal">
              Select a discount to apply
            </div>
          </div>
        ),
        content: (onClose) => (
          <div className="pt-3">
            <DiscountModal
              onClose={onClose}
              value={discounts}
              onChange={handleOnChange}
              includes={includes}
            />
          </div>
        ),
        modalSize: 'modal-xs',
      });
      return;
    }

    showModal({
      title: (
        <div>
          <div>Add Discount</div>
          <div className="text-sm font-normal">Select a discount to apply</div>
        </div>
      ),
      content: (onClose) => (
        <div className="pt-3">
          <DiscountModal
            onClose={onClose}
            value={discounts}
            onChange={handleOnChange}
            includes={includes}
          />
        </div>
      ),
      modalSize: 'modal-xs',
    });
  };

  const handleOnRemoveDiscount = (row) => (e) => {
    e.stopPropagation();
    setDiscounts((prevState) => {
      const v = prevState?.discount_type?.filter(
        (item) => item?.key !== row?.key
      );

      setCart(($prevState) =>
        $prevState?.map((item) => ({
          ...item,
          discount_type: v?.length > 0 ? v : null,
        }))
      );

      if (v?.length <= 0) {
        return DEFAULT_FORM;
      }

      return {
        ...prevState,
        discount_type: v,
      };
    });
  };

  return (
    <div>
      {discounts?.discount_type?.length > 0 ? (
        <div
          className="space-y-2 -mt-1 cursor-pointer hover:bg-opacity-95"
          onClick={handleOnClick}
          role="presentation"
        >
          {discounts?.discount_type?.map((item, key) => {
            const k = key;
            return (
              <div
                className="btn gray !bg-white rounded w-full text-left flex items-center gap-2 !pl-4 border border-dashed border-primary-500"
                key={k}
              >
                <div className="flex-1 text-sm font-medium text-primary-500 flex items-center gap-2">
                  <div>
                    <HiOutlineTicket className="h-5 w-5" />
                  </div>
                  <div>
                    {item?.name} ({item?.value}%)
                  </div>
                </div>
                <div>
                  <IoClose
                    className="h-5 w-5 cursor-pointer text-primary-500"
                    onClick={handleOnRemoveDiscount(item)}
                  />
                </div>
              </div>
            );
          })}
        </div>
      ) : (
        <Button
          className={cn('btn bg-transparent border border-gray-400 w-full', {
            'text-white': !isAlertModal,
          })}
          disabled={cart?.length <= 0 && disabledButton}
          label={
            <div className="flex items-center gap-3 justify-center py-0.5">
              <HiOutlineTicket className="h-6 w-6" />
              <div>Add Discount</div>
            </div>
          }
          onClick={handleOnClick}
        />
      )}
    </div>
  );
}

Discounts.defaultProps = {
  disabledButton: true,
  isAlertModal: false,
};

Discounts.propTypes = {
  disabledButton: PropTypes.bool,
  isAlertModal: PropTypes.bool,
};

export default Discounts;
